module.exports = __webpack_public_path__ + "loading.svg?4035b30200eb82aca8f12e79a5fc7925";


//////////////////
// WEBPACK FOOTER
// ./client/assets/loading-gif/loading.svg
// module id = 67
// module chunks = 0